import { GrcNotify, NotifyType } from '@grc/ui-package';
import { orderService } from '@grc/ui-shared/lib/components/common/constants/constants';
import { fetchShipments } from '../../common/constants/url-constants';
import { IShipment } from '../../models/shipments/shipment.interface';

const inflightShipments = new Map<string, Promise<IShipment[]>>();

export const GetShipments = async (
  fetchData: any,
  params: Record<string, unknown>
): Promise<IShipment[]> => {
  const key = JSON.stringify(params ?? {});
  const existing = inflightShipments.get(key);
  if (existing) return existing;

  const request = fetchData(
    fetchShipments,
    (message: string) => GrcNotify({ message, status: NotifyType.Error }),
    orderService,
    params
  )
    .then((response: any) => (response?.data as IShipment[]) ?? [])
    .catch((error: any) => {
      GrcNotify({ message: error.message, status: NotifyType.Error });
      return [] as IShipment[];
    })
    .finally(() => {
      inflightShipments.delete(key);
    });

  inflightShipments.set(key, request);
  return request;
};

export default GetShipments;
